import { CardContent, Typography } from "@material-ui/core";
import { Grid, Card } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "./constants";
import "./WrapperReport.scss";

const ChartTask = ({ statisticTask }) => {
  const { t } = useTranslation();
  const data = {
    options: {
      legend: { show: true, position: "bottom" },
      labels: [
        t("PROJECT_PAGE.REPORT.WAIT"),
        t("PROJECT_PAGE.REPORT.PROCESS"),
        t("PROJECT_PAGE.REPORT.DONE"),
        t("PROJECT_PAGE.REPORT.EXPIRED"),
      ],
      colors: [colors.WAITING, colors.DOING, colors.COMPLETE, colors.EXPIRED],
    },
    series: [
      statisticTask?.waiting,
      statisticTask?.doing,
      statisticTask?.complete,
      statisticTask?.expired,
    ],
  };

  return (
    <WrapperGrid item xs={12} md={6}>
      <Card
        style={{ height: "400px" }}
        sx={{
          "&:hover": {
            boxShadow:
              "rgb(0 0 0 / 16%) 0px 10px 36px 0px, rgb(0 0 0 / 6%) 0px 0px 0px 1px",
          },
          borderRadius: "20px",
          boxShadow: "unset",
        }}
      >
        <CardContent>
          <Typography variant="h6" component="div" style={{ fontSize: "15px" }}>
            {t("PROJECT_PAGE.REPORT.WORK_SUMARY")}
          </Typography>

          <div className="chart-task__donut">
            <Chart res type="donut" width={"100%"} height={"320px"} {...data} />
          </div>
        </CardContent>
      </Card>
    </WrapperGrid>
  );
};
const WrapperGrid = styled(Grid)`
  margin-top: 20px;
  min-width: 300px;
  padding: 16px 16px 0px 16px !important;
  // @media (max-width: 768px) {
  //   max-width: calc(100% - 12rem);
  //   overflow: auto;
  // }
`;
export default ChartTask;
